import React, { type JSX, useContext } from 'react';

import BrandThemeProvider from '@rover/kibble/themes/BrandThemeProvider';
import RoverBrandContext from '@rover/react-lib/src/context/RoverBrandContext';
import { RoverBrand } from '@rover/types/src/RoverBrand';

import { useActiveSeason } from './useActiveSeason';

type Props = {
  children: React.ReactNode;
};

/** Applies the active season's theme to its children only. */
const SeasonalThemeBoundary = ({ children }: Props): JSX.Element => {
  const brand = useContext(RoverBrandContext)?.brand ?? RoverBrand.Rover;
  const season = useActiveSeason();

  // Always render the provider so the subtree doesn't remount when the season resolves.
  return (
    <BrandThemeProvider brand={brand} season={season}>
      {children}
    </BrandThemeProvider>
  );
};

export default SeasonalThemeBoundary;
